import { DEFAULT_LOCATIONS, SURGERY_PLUS, CHECKMARK } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token d7b1fd5b743e814c1ced5308af3e9816d81fa43a',
  staging: 'Token 8aabcb9b67e4a4bc9082b9dcc47ca5b762ffd2aa',
  prod: 'Token 3ebb19b307fe12abd5d4b25914782b63729e9ea6',
};

const token = selectToken(apiTokens);

const surgeryPlusConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'lantern',

  API_TOKEN: token,
  EMBOLD_CLIENT: SURGERY_PLUS,

  // login
  SHOW_REGION_SELECTOR: false,

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Dallas },
  DEFAULT_SEARCH_RADIUS: 50,
  LOGIN_NETWORK_NAME: 'surgeryPlusUserId',

  // content
  DISPLAY_NAME: 'Lantern',
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: false,
};

export default surgeryPlusConfig;
